<template>
  <div class="LanguageMenu">
    <p-dropdown-menu :dropped.sync="isDropped">
      <span slot="label">
        <div class="UserMenu__Label d-none d-md-block hidden-xs-down">
          {{ selected.title }}
        </div>
        <div class="d-md-none">{{ selected.abr }}</div>
      </span>
      <div slot="dropdown" class="LanguageMenu_List">
        <div
          v-for="entry in languages"
          v-bind:key="entry.language"
          @click="changeLocale(entry.language)"
        >
          <div>{{ entry.title }}</div>
        </div>
      </div>
    </p-dropdown-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Options from "@/options";
import DropdownMenu from "./DropdownMenu";

import i18n from "@/plugins/i18n";

export default {
  name: "LanguageMenu",
  components: {
    "p-dropdown-menu": DropdownMenu,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  computed: {
    selected() {
      return this.languages.find((lang) => lang.language === this.lang);
    },
    ...mapGetters({
      lang: "settings/lang",
    }),
  },
  watch: {
    lang: {
      immediate: true,
      handler(value) {
        i18n.locale = value;
      },
    },
  },
  methods: {
    changeLocale(value) {
      this.setSetting({ setting: "lang", value });
    },
    ...mapActions({
      setSetting: "settings/setSetting",
    }),
  },
  created() {
    this.languages = Options.languages;
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.LanguageMenu_List {
  width: auto;
  padding: 0 20px 0 15px;
  white-space: nowrap;
}
.UserMenu {
  display: inline-block;
  font-size: 16px;
}
.LanguageMenu {
  display: inline-block;
}

.UserMenu__Label {
  color: #fff;
  display: inline-block;

  @include breakpoint-manual(max-width, $break-extra-small - 1px) {
    display: none;
  }
}

.UserMenu__List-Header {
  color: #777;
  font-weight: 700;
  font-size: 15px;
  display: block;
  padding: 10px 20px 2px;
  margin: 18px 0 5px;
}

.UserMenu__List-Icon {
  float: right;
  margin: 3px 0 0;
}
</style>

